import { useEffect, useMemo, useRef, useState } from 'react'
import { Dish } from 'app/dataTypes/dishes/dish'
import toFixedValue from 'app/common/lib/toFixedValue'

export const useTotalsState = ({
  dishTechItems,
}: {
  dishTechItems: Array<{ gross: string; net: string; dish: Dish | null }>
}) => {
  const [totalGrossByUser, setTotalGrossByUser] = useState('')
  const [totalNetByUser, setTotalNetByUser] = useState('')

  const [totalGrossDrivenByUser, setTotalGrossDrivenByUser] = useState(false)
  const [totalNetDrivenByUser, setTotalNetDrivenByUser] = useState(false)

  const previosGrossCalculated = useRef(0)
  const previosNetCalculated = useRef(0)

  const [totalGrossCalculated, totalNetCalculated] = useMemo(() => {
    return dishTechItems.reduce(
      ([accGross, accNet], { gross, net, dish }) => {
        if (!dish) {
          return [accGross, accNet]
        }
        const grossNum = parseFloat(gross)
        const netNum = parseFloat(net)
        return [
          isNaN(grossNum) ? accGross : accGross + grossNum,
          isNaN(netNum) ? accNet : accNet + netNum,
        ]
      },
      [0, 0],
    )
  }, [dishTechItems])

  useEffect(() => {
    if (previosGrossCalculated.current !== totalGrossCalculated) {
      setTotalGrossDrivenByUser(false)
    }
    previosGrossCalculated.current = totalGrossCalculated
  }, [totalGrossCalculated])

  useEffect(() => {
    if (previosNetCalculated.current !== totalNetCalculated) {
      setTotalNetDrivenByUser(false)
    }
    previosNetCalculated.current = totalNetCalculated
  }, [totalNetCalculated])

  return {
    totalGross: totalGrossDrivenByUser ? totalGrossByUser : toFixedValue(totalGrossCalculated),
    totalNet: totalNetDrivenByUser ? totalNetByUser : toFixedValue(totalNetCalculated),

    setTotalGrossByUser: (value: string) => {
      setTotalGrossByUser(value)
      setTotalGrossDrivenByUser(true)
    },
    setTotalNetByUser: (value: string) => {
      setTotalNetByUser(value)
      setTotalNetDrivenByUser(true)
    },

    handleGrossBlur: () => {
      if (!totalGrossByUser) {
        setTotalGrossDrivenByUser(false)
      }
    },
    handleNetBlur: () => {
      if (!totalNetByUser) {
        setTotalNetDrivenByUser(false)
      }
    },
  }
}
